import React, { FC } from 'react'
import { InputLabel } from './Styles'

type FormInputLabelProps = {
  autoComplete?: string
  disabled?: boolean
  error?: string
  inputMode?: string
  maxLength?: string | number
  name: string
  onBlur?: (...args: Array<any>) => any
  onChange: (...args: Array<any>) => any
  onFocus?: (...args: Array<any>) => any
  onKeyDown?: (...args: Array<any>) => any
  onWheel?: (...args: Array<any>) => any
  pattern?: string
  placeholder?: string
  readOnly?: boolean
  type?: string
  value: string | null | undefined
  dataStyle?: string
}

const FormInputLabel: FC<FormInputLabelProps> = (props) => {
  const {
    autoComplete,
    disabled,
    error,
    maxLength,
    name,
    onBlur,
    onChange,
    onFocus,
    onKeyDown,
    onWheel,
    placeholder,
    readOnly,
    type,
    value = '',
    dataStyle = '',
  } = props
  return (
    <InputLabel
      data-type='input'
      data-field={name}
      {...(error
        ? {
            'data-error': 'true',
          }
        : {})}
    >
      <input
        autoComplete={autoComplete}
        maxLength={Number(maxLength) || undefined} // protect from NaN
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        onWheel={onWheel}
        placeholder={placeholder}
        type={type || 'text'}
        value={String(value)}
        data-style={dataStyle}
        {...(readOnly
          ? {
              readOnly: true,
            }
          : {})}
        {...(disabled
          ? {
              disabled: true,
            }
          : {})}
      />

      {placeholder && <label htmlFor={name}>{placeholder}</label>}

      {error && <span data-type='error'>{error}</span>}
    </InputLabel>
  )
}

export default FormInputLabel
